/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react';
import { useUnauthorizedContext } from './useUnauthorizedContextHook';
import doxExplorerCDMServices from '../services/doxExplorerCDMServices';

export const useFileSearch = (ticket_id, sortOverride, searchValue) => {
    const handleUnauthorized = useUnauthorizedContext()
    const [sortColumn, setSortColumn] = useState(null);
    const [sortDirection, setSortDirection] = useState(false)
    const [fileList, setFileList] = useState([])
    const [filteredFileList, setFilteredFileList] = useState([])
    const [status, setStatus] = useState(null)
    const [loaded, setLoaded] = useState(false)
    const [lastUpdated, setLastUpdated] = useState(null)
    const [ticketId, setTicketId] = useState(null)

    const updateSort = (col, dir) => {
        if (sortColumn !== col) {
            setSortColumn(col)
        }
        if (sortDirection !== dir) {
            setSortDirection(dir)
        }
    }
    
    const deleteFile = async (documentId) => {
        if (await doxExplorerCDMServices.deleteFile(handleUnauthorized, documentId)) {
            let fl = fileList.filter(x => x.documentId !== documentId)
            setFileList(fl)
            return true
        } else {
            return false
        }
    }

    const reloadFileList = async () => {
        setLoaded(false)
        retrieveData();
    }

    const retrieveData = async () => {
        var { status: st, fileList: fl } =
            await doxExplorerCDMServices.getSortedFileList(handleUnauthorized, ticketId, sortColumn, sortDirection);
        setLastUpdated(new Date().getTime())
        setFileList(fl)
        setStatus(st)
        setLoaded(true)
    }

    const renameFile = async (documentId, newFileName, ticketId) => {
        var file = fileList.find(x => x.documentId === documentId)
        if (file) {
            var metaDataRequest = {
                FileName: newFileName,
                ClientDescription: '',
                // it is fileType (not documentType) that contains extension name
                DocumentType: file.fileType || '',
                DocumentStateus: file.documentStatus
            }
        
            if (file && await doxExplorerCDMServices.updateFileMetadata(handleUnauthorized, documentId, ticketId, metaDataRequest)) {
                file.fileName = newFileName
                return true
            }
        }
        return false
    }

    useEffect(() => {
        if (sortOverride) {
            if (sortOverride !== sortColumn) {
                setSortColumn(sortOverride)
            }
            if (sortDirection) {
                setSortDirection(false);
            }
        }
    }, [sortOverride])

    useEffect(() => {
        if (!searchValue) {
            setFilteredFileList(fileList)
        } else {
            var sv = searchValue.toLowerCase()
            setFilteredFileList(fileList.filter(f => (f.fileName + f.fileType).toLowerCase().includes(sv)))
        }
    }, [fileList, searchValue, setFilteredFileList])

    useEffect(() => {
        async function retrieveData() {
            var { status: st, fileList: fl } =
                await doxExplorerCDMServices.getSortedFileList(handleUnauthorized, ticketId, sortColumn, sortDirection);
            setLastUpdated(new Date().getTime())
            setFileList(fl)
            setStatus(st)
            setLoaded(true)
        }

        if (ticketId) {
            if (!lastUpdated || new Date().getTime() - lastUpdated > 120000) {
                setLoaded(false)
                retrieveData();
            } else {
                setFileList(doxExplorerCDMServices.sortFileList(fileList, sortColumn, sortDirection))
            }
        }
    }, [ticketId, sortColumn, sortDirection])

    useEffect(() => {
        if (ticketId !== ticket_id) {
            setLastUpdated(null)
            setTicketId(ticket_id)
        }
    }, [ticket_id])

    return [sortColumn, sortDirection, updateSort, status, fileList, filteredFileList, loaded, deleteFile, renameFile, reloadFileList]
}